.toolbar {
  padding: 8px 0;
}
